import React from "react";
import { normalizeUrl } from "../utils/utils";

export default function LogoHeader({
  organizationName,
  organizationDescription,
  imageLogo,
}) {
  return (
    <div className="text-center mb-10 mt-5 animate-fade-in">
      {imageLogo ? (
        <img
          src={normalizeUrl(imageLogo)}
          style={{ height: "150px", marginBottom: "10px" }}
          alt={`${organizationName} logo`}
          className="w-full h-full object-contain p-2"
        />
      ) : (
        <span className="text-white font-bold text-3xl">G</span>
      )}
      <h3 className="text-3xl font-bold bg-gradient-to-r from-primary-600 to-primary-800 bg-clip-text text-transparent mb-2">
        {`Welcome to ${organizationName}`}
      </h3>
      <p className="text-gray-600 text-sm">{organizationDescription}</p>
    </div>
  );
}
